import { TagMultipleIcon } from './TagMultipleIcon';

/**
 * author: Austin Andrews
 * id 408AB5A3-F100-4175-96CD-8602BE101150
 * name tag-multiple
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tag-multiple.svg
 * tags
 */
export const TagsIcon = TagMultipleIcon;
export default TagsIcon